import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export const communityShowAuthModalAtom = atom(false);

export const selectedCancerFocusAtom = atomWithReset<string | undefined>(undefined);
